const MAX_LINES = 80
let panelEl = null
let bodyEl = null
let urlEl = null
let sessionLogs = []
let pageContext = {
  href: '',
  signUrl: '',
  host: '',
  websiteUrl: ''
}

function formatPayload(payload) {
  if (payload === undefined || payload === null) return ''
  if (typeof payload === 'string') return payload
  try {
    return JSON.stringify(payload, null, 2)
  } catch (e) {
    return String(payload)
  }
}

function ensurePanel() {
  if (panelEl) return panelEl

  const style = document.createElement('style')
  style.textContent = `
    #member-ding-debug-panel {
      position: fixed;
      left: 8px;
      right: 8px;
      bottom: 8px;
      max-height: 45vh;
      z-index: 99999;
      background: rgba(20, 24, 32, 0.94);
      color: #e8eaed;
      border: 1px solid #5f6368;
      border-radius: 8px;
      font-size: 12px;
      line-height: 1.45;
      box-shadow: 0 4px 24px rgba(0,0,0,0.35);
      display: none;
      flex-direction: column;
      font-family: Menlo, Monaco, Consolas, monospace;
    }
    #member-ding-debug-panel.is-visible { display: flex; }
    #member-ding-debug-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 10px;
      border-bottom: 1px solid #3c4043;
      flex-shrink: 0;
    }
    #member-ding-debug-header strong { font-size: 13px; color: #8ab4f8; }
    #member-ding-debug-url {
      padding: 8px 10px;
      border-bottom: 1px solid #3c4043;
      flex-shrink: 0;
      background: rgba(255,255,255,0.04);
    }
    #member-ding-debug-url .label {
      color: #8ab4f8;
      font-size: 11px;
      margin-bottom: 4px;
    }
    #member-ding-debug-url pre {
      margin: 0;
      white-space: pre-wrap;
      word-break: break-all;
      color: #e8eaed;
      font-size: 11px;
      line-height: 1.4;
    }
    #member-ding-debug-url .meta {
      margin-top: 6px;
      color: #9aa0a6;
      font-size: 11px;
      line-height: 1.5;
    }
    #member-ding-debug-actions button {
      margin-left: 6px;
      padding: 2px 8px;
      font-size: 11px;
      cursor: pointer;
      border: 1px solid #5f6368;
      background: #303134;
      color: #e8eaed;
      border-radius: 4px;
    }
    #member-ding-debug-body {
      overflow: auto;
      padding: 8px 10px;
      flex: 1;
      min-height: 0;
    }
    .member-ding-debug-line {
      margin-bottom: 8px;
      word-break: break-all;
    }
    .member-ding-debug-line .step { color: #fdd663; }
    .member-ding-debug-line .time { color: #9aa0a6; margin-right: 6px; }
    .member-ding-debug-line pre {
      margin: 4px 0 0;
      padding: 6px 8px;
      background: rgba(255,255,255,0.06);
      border-radius: 4px;
      white-space: pre-wrap;
      color: #c4c7c5;
    }
    .member-ding-debug-line .api-url {
      display: block;
      margin-top: 4px;
      padding: 6px 8px;
      background: rgba(138, 180, 248, 0.12);
      border-radius: 4px;
      color: #aecbfa;
      word-break: break-all;
      white-space: pre-wrap;
    }
    .member-ding-debug-line.is-error .step { color: #f28b82; }
  `
  document.head.appendChild(style)

  panelEl = document.createElement('div')
  panelEl.id = 'member-ding-debug-panel'
  panelEl.innerHTML = `
    <div id="member-ding-debug-header">
      <strong>钉钉免登调试</strong>
      <div id="member-ding-debug-actions">
        <button type="button" data-action="clear">清空</button>
        <button type="button" data-action="hide">关闭</button>
      </div>
    </div>
    <div id="member-ding-debug-url"></div>
    <div id="member-ding-debug-body"></div>
  `
  document.body.appendChild(panelEl)
  bodyEl = panelEl.querySelector('#member-ding-debug-body')
  urlEl = panelEl.querySelector('#member-ding-debug-url')

  panelEl.querySelector('[data-action="hide"]').addEventListener('click', () => {
    panelEl.classList.remove('is-visible')
  })
  panelEl.querySelector('[data-action="clear"]').addEventListener('click', () => {
    sessionLogs = []
    renderLogs([])
  })

  return panelEl
}

function renderPageContext() {
  ensurePanel()
  if (!urlEl) return
  const ctx = pageContext
  urlEl.innerHTML = ''
  const label = document.createElement('div')
  label.className = 'label'
  label.textContent = '当前链接'
  const hrefPre = document.createElement('pre')
  hrefPre.textContent = ctx.href || location.href
  urlEl.appendChild(label)
  urlEl.appendChild(hrefPre)
  const metaLines = []
  if (ctx.host) metaLines.push('host: ' + ctx.host)
  if (ctx.websiteUrl) metaLines.push('websiteUrl: ' + ctx.websiteUrl)
  if (ctx.signUrl && ctx.signUrl !== ctx.href) metaLines.push('JSAPI签名URL: ' + ctx.signUrl)
  if (metaLines.length) {
    const meta = document.createElement('div')
    meta.className = 'meta'
    meta.textContent = metaLines.join('\n')
    urlEl.appendChild(meta)
  }
}

function renderLogs(logs) {
  ensurePanel()
  renderPageContext()
  if (!bodyEl) return
  bodyEl.innerHTML = ''
  const list = logs.slice(-MAX_LINES)
  list.forEach((item) => {
    const line = document.createElement('div')
    line.className = 'member-ding-debug-line' + (item.isError ? ' is-error' : '')
    const time = new Date(item.time).toLocaleTimeString()
    line.innerHTML = `<span class="time">${time}</span><span class="step">${item.step}</span>`
    if (item.payload !== undefined) {
      const payload = item.payload
      if (payload && typeof payload === 'object' && payload.apiUrl) {
        const apiSpan = document.createElement('span')
        apiSpan.className = 'api-url'
        apiSpan.textContent = '接口: ' + payload.apiUrl
        line.appendChild(apiSpan)
        const rest = { ...payload }
        delete rest.apiUrl
        const restKeys = Object.keys(rest)
        if (restKeys.length > 0) {
          const pre = document.createElement('pre')
          pre.textContent = formatPayload(rest)
          line.appendChild(pre)
        }
      } else {
        const pre = document.createElement('pre')
        pre.textContent = formatPayload(item.payload)
        line.appendChild(pre)
      }
    }
    bodyEl.appendChild(line)
  })
  bodyEl.scrollTop = bodyEl.scrollHeight
}

const DingDebugPanel = {
  setPageContext(ctx) {
    pageContext = {
      href: (ctx && ctx.href) || location.href,
      signUrl: (ctx && ctx.signUrl) || '',
      host: (ctx && ctx.host) || location.host,
      websiteUrl: (ctx && ctx.websiteUrl) || ''
    }
  },

  clearSession() {
    sessionLogs = []
    renderLogs([])
  },

  log(step, payload, options) {
    options = options || {}
    sessionLogs.push({
      step,
      payload,
      time: Date.now(),
      isError: !!options.isError
    })
    if (sessionLogs.length > MAX_LINES) {
      sessionLogs = sessionLogs.slice(-MAX_LINES)
    }
    return sessionLogs
  },

  flush(show) {
    this.setPageContext({
      href: location.href,
      signUrl: pageContext.signUrl,
      host: location.host,
      websiteUrl: pageContext.websiteUrl
    })
    renderLogs(sessionLogs)
    if (show !== false) {
      ensurePanel()
      panelEl.classList.add('is-visible')
    }
  },

  showError(step, payload) {
    this.log(step, payload, { isError: true })
    this.flush(true)
  }
}

export default DingDebugPanel
